import React from 'react';
import { motion } from 'framer-motion';
import { Check, ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';
import './ServiceCard.css';

const ServiceCard = ({ service, index }) => {
  const getServicePath = (title) => {
    const paths = {
      'Safety Valve Service & Spares': '/services/safety-valve',
      'Safety Valve and Breather Valves': '/services/safety-valve',
      'Electric & Pneumatic Actuator Maintenance': '/services/actuator',
      'Control, Isolation, ARC Valves Servicing & Refurbishment': '/services/valve-service',
      'Control & Isolation Valves Servicing & Refurbishment': '/services/valve-service',
      'ARC Valve Service': '/services/arc-valve',
      'Boiler Feed Pump Support': '/services/bfp-service',
      'Pump Services': '/services/bfp-service',
      'Genuine Spares Supply': '/services/spares',
      'Workshop Support Services': '/services/workshop'
    };
    return paths[title] || '/services';
  };

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6, delay: index * 0.2 }}
      className="service-card"
    >
      <div className="service-card-icon">
        <div className="service-icon-wrapper">
          {service.icon}
        </div>
      </div>

      <h3 className="service-card-title">
        {service.title}
      </h3>

      <p className="service-card-description">
        {service.description}
      </p>

      <div className="service-features">
        {service.features.map((feature, featureIndex) => (
          <div key={featureIndex} className="service-feature-item">
            <div className="service-feature-check">
              <Check className="w-3 h-3 text-primary-600" />
            </div>
            <span className="service-feature-text">{feature}</span>
          </div>
        ))}
      </div>

      <Link to={getServicePath(service.title)} className="service-card-link">
        <span>Learn More</span>
        <ArrowRight className="w-4 h-4" />
      </Link>
    </motion.div>
  );
};

export default ServiceCard;
